import * as React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { HashRouter as Router } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

import { ToastProvider } from "common/context/toast/toast-context";
import theme from "common/themes/default.theme";
import store from "common/rdx/store.config";
import { CustomMSALProvider } from "common/context/auth/msal/msal-context";
import { AuthProvider } from "common/context/auth/auth-context";

const queryClient = new QueryClient();

function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <CustomMSALProvider>
          <AuthProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />

              <ToastProvider>
                <ReduxProvider store={store}>{children}</ReduxProvider>
              </ToastProvider>
            </ThemeProvider>
          </AuthProvider>
        </CustomMSALProvider>
      </Router>

      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
}

export default AppProviders;
